<script>
import Titre from "@/components/atoms/titre";
import Divider from "@/components/atoms/divider";
import { storeLocatorEmits, storeLocatorProps, useStoreLocator } from "./mixin";

import pictoStorelocEasybox from "@/assets/images/picto-storeloc-easybox.svg";
import pictoStorelocLaposte from "@/assets/images/picto-storeloc-laposte.svg";
import pictoStorelocCev from "@/assets/images/picto-storeloc-cev.svg";
import pinR from "@/assets/images/pin-r.svg";
import placeholderCora from "@/assets/images/placeholder-cora.svg";
import placeholderCarrefour from "@/assets/images/placeholder-carrefour.png";

export default {
  name: "StoreLocator",
  components: {
    Titre,
    Divider
  },
  props: {
    ...storeLocatorProps()
  },
  emits: [...storeLocatorEmits()],
  setup(props, context) {
    const {
      storeLocatorHeight,
      storeStyleHeight,
      initWoosmapScript,
      beforeUnmount
    } = useStoreLocator(props, context);

    onMounted(async () => {
      await initWoosmapScript(false);
    });

    onBeforeUnmount(beforeUnmount);

    return {
      storeLocatorHeight,
      storeStyleHeight,
      initWoosmapScript,
      pictoStorelocEasybox,
      pictoStorelocLaposte,
      pictoStorelocCev,
      pinR,
      placeholderCora,
      placeholderCarrefour
    };
  }
};
</script>

<template>
  <div class="c-storelocator__container">
    <Titre
      tag="h2"
      class="c-storelocator__title u-text-center u-mb-xs u-mt-xs"
    >
      Trouver mon magasin
    </Titre>
    <div
      id="store-locator"
      class="c-storelocator"
      :style="storeStyleHeight"
    />
    <div class="c-storelocator__legend-button-container">
      <span>
        Légende :
      </span>
      <div class="c-storelocator__legend-item">
        <img
          :src="placeholderCarrefour"
          width="32"
          height="32"
        />
        Hypermarché - Commande sur carrefour.fr
      </div>
      <Divider
        vertical
        class="u-m-none"
      />
      <div class="c-storelocator__legend-item">
        <img
          :src="placeholderCora"
          width="32"
          height="32"
        />
        Hypermarché - Commande sur cora.fr
      </div>
      <Divider
        vertical
        class="u-m-none"
      />
      <div class="c-storelocator__legend-item">
        <img
          :src="pinR"
          width="32"
          height="32"
        />
        Point de retrait commerçant
      </div>
      <Divider
        vertical
        class="u-m-none"
      />
      <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocCev"
          width="32"
          height="32"
        />
        Drive piéton
      </div>
      <Divider
        vertical
        class="u-m-none"
      />
      <!-- <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocEasybox"
          width="32"
          height="32"
        />
        Easybox
      </div>
       <Divider
        vertical
        class="u-m-none"
      />
      <div class="c-storelocator__legend-item">
        <img
          :src="pictoStorelocLaposte"
          width="32"
          height="32"
        />
        La poste
      </div> -->
    </div>
  </div>
</template>

<style lang="scss">
@import "@/assets/styles/components/header-store-locator.scss";
</style>
